import { render, staticRenderFns } from "./RirekishoDoubleNophotoPreview.vue?vue&type=template&id=6f95f7f9"
import script from "./RirekishoDoubleNophotoPreview.vue?vue&type=script&lang=js"
export * from "./RirekishoDoubleNophotoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports